export class Quotation {
  name: string;
  lang: string;
  dates: {
    start: Date | null,
    end: Date | null,
  };
  waiters: number;
  cashRegisters: number;
  printers: number;
  email: string;

  constructor() {
    this.name = '';
    this.lang = '';
    this.dates = {
      start: null,
      end: null,
    };
    this.waiters = 0;
    this.cashRegisters = 0;
    this.printers = 0;
    this.email = '';
  }
}
